const Offers = () => {
    return (
        <div>
            Hello From Offer Page
        </div>
    )
}

export default Offers